import React from 'react';
import { motion } from 'framer-motion';
import { PageHero } from '../components/PageHero';
import { CTASection } from '../components/CTASection';
export function WhySureAI() {
  const valueStatements = ['No new cameras required', 'No identity tracking', 'Designed for regulated environments and auditable decisions'];
  return <>
      <PageHero eyebrow="WHY SURE AI" headline="Infrastructure for decision-making in public transport" data-id="element-513" />

      {/* Key Value Statements */}
      <section className="bg-sure-dark w-full py-24 md:py-32" data-id="element-514">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12" data-id="element-515">
          <div className="flex flex-col space-y-12 max-w-4xl" data-id="element-516">
            {valueStatements.map((statement, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: index * 0.2
          }} className="flex items-start space-x-6" data-id="element-517">
                <div className="flex-shrink-0 w-3 h-3 bg-sure-accent mt-3 md:mt-4 rounded-full" data-id="element-518" />
                <h2 className="text-sure-white text-3xl md:text-4xl lg:text-5xl font-bold leading-tight" data-id="element-519">
                  {statement}
                </h2>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Value Proposition */}
      <section className="bg-sure-black w-full py-24 md:py-32 border-t border-white/5" data-id="element-520">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12" data-id="element-521">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="max-w-4xl" data-id="element-522">
            <h3 className="text-sure-accent text-xs md:text-sm uppercase tracking-widest font-medium mb-8" data-id="element-523">
              Value Proposition
            </h3>
            <p className="text-sure-gray text-lg md:text-xl font-light leading-relaxed" data-id="element-524">
              SURE AI turns existing onboard systems into a continuous source of
              operational evidence, so decisions are measurable, explainable and
              defensible across the network. As deployment expands, intelligence
              becomes increasingly consistent, comparable and valuable at system
              level.
            </p>
          </motion.div>
        </div>
      </section>

      <CTASection data-id="element-525" />
    </>;
}